import { useRuntimeConfig, useFetch, useNuxtApp, createError } from 'nuxt/app'
import { ref, computed } from 'vue'

interface ApiResponse<T> {
    data: T;
    data_count: number;
    error_code: number;
    error_message: string;
}

interface NestedData<T> {
    data: T;
}

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD' | 'OPTIONS';

export const useApiFetch = async <T>(
    path: string,
    method: HttpMethod = 'GET',
    body: any = null,
    header?: HeadersInit,
    extra: {} = {},
) => {
    const config = useRuntimeConfig();
    const nuxtApp = useNuxtApp();
    //const auth = useAuthStore();
    header = {
        ...header,
        /*Authorization: `Bearer ${auth.getToken()}`,*/
    };

    // Body'yi key'e dahil et ki POST requestlerde cache karışmasın
    const cacheKey = body ? `${method}:${path}:${JSON.stringify(body)}` : `${method}:${path}`;

    const { data, status, error, refresh, execute, pending } = await useFetch<ApiResponse<T>>(path, {
        baseURL: config.public.apiBase as string,
        method: method,
        body: body,
        headers: header,
        key: cacheKey,
        server: true,
        lazy: false,
        immediate: true,
        dedupe: 'cancel',
        getCachedData(key) {
            return nuxtApp.ssrContext?.cache?.[key] ?? nuxtApp.payload.data[key]
        },
        default: () => ({ data: [] as T, data_count: 0, error_code: 0, error_message: '' } as ApiResponse<T>),
        ...extra,
    });
    
    let err;
    if (error.value) {
        const statusCode = error.value.statusCode || 500
        const statusMessage = error.value?.data?.error_message || error.value.message || (statusCode === 404 ? 'Sayfa bulunamadı' : statusCode === 403 ? 'Erişim engellendi' : 'Bir hata oluştu')

        // Kurs bulunamadı gibi 404 senaryolarında SSR tarafında doğru kodla hata sayfasına düşelim
        throw createError({ statusCode, statusMessage })
    }

    const valueData = computed(() => data.value?.data ?? ({} as T));
    return { data: valueData, status, pending, err, refresh, execute };
};
